import flatMap from "lodash/flatMap";
import map from "lodash/map";
import pickBy from "lodash/pickBy";
import values from "lodash/values";
import { FormCustomFieldValue } from "PFApp/types/activity_form/activity_form_schema";
import { getConnectedProperties } from "PFCore/helpers/templates";
import { Id, ParsedSchemaProperty, Subtemplate, Template } from "PFTypes";

type UseConnectedFields = {
  property?: ParsedSchemaProperty;
  template: Template;
  subtemplate: Subtemplate | null;
  customFields: Record<string, FormCustomFieldValue>;
};

export const useConnectedFields = ({
  property,
  template,
  subtemplate,
  customFields
}: UseConnectedFields): Id[] => {
  if (property && !property.connected_options) {
    return [];
  }

  const connectedPropertiesNames = getConnectedProperties(subtemplate || template).map(({ name }) => name);

  return flatMap(
    values(
      pickBy(
        customFields,
        // Exclude the current field's own values — a field should not constrain itself
        (values, fieldName) =>
          connectedPropertiesNames.includes(fieldName) &&
          fieldName !== property?.name &&
          values &&
          values.length > 0
      )
    ),
    (values) => map(values, "id")
  );
};
